export default __webpack_public_path__ + "static/industrials-5e9d1894aaf83a2706e563ed611db065.png";